import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

// images
import hero from "./Images/hero.svg";
import image1 from "./Images/galleryimage1.svg";
import image2 from "./Images/galleryimage2.svg";
import image3 from "./Images/galleryimage3.svg";
import { LucideIcon, Coffee, Users, Smile, Presentation, Bell, Gift } from "lucide-react";

//icons
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { blogs } from "../../Blogs copy/BlogData";
import BlogList from "../../Blogs copy/BlogList";
import axios from "axios";
import Meetingagenda from "./MeetinDesign/Meetingagenda";


interface datastructure{
  title:string,
  content:string,
  id:number,
  image:string,
  name:String,
}

interface banner{
  title:string,
  content:string,
  id:number,
  image:string,
  pageName:String,
}
interface Phase {
  title: string;
  details: string[];
  icon: JSX.Element; // Store the icon as a JSX element
  color: string;
}


const Meetings = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const[bannerdata, setBannerdata] = useState<banner[]>([]);
  const[pagedata, setPagedata] = useState<datastructure[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          `${api}/auth/meetingdata`,{
            
      });

        //console.log('meetingdata data',response.data)
        setPagedata(response.data);
        //console.log("meetingdata data in a array",pagedata);
      } catch (error) {
        console.error("meetingdata Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<banner[]>(
          `${api}/auth/meetingbanner`,{
            
      });

        //console.log('meeting banner data',response.data)
        setBannerdata(response.data);
        //console.log("banner data in a array",bannerdata);
      } catch (error) {
        console.error("meeting banner Not Found:", error);
      }
    };

    fetchData();
  }, []);

const phases = [
    {
      num: "01",
      title: "Tea/Coffee",
      details: ["Open Networking", "Exchange of Cards- Fellowship"],
      color: "from-orange-100 to-orange-200",
      pin: "bg-orange-500",
    },
    {
      num: "02",
      title: "Meeting Starts Sharp 8:30AM",
      details: [
        "Welcome everyone, and introduce Team Leaders and Coordinators",
        "4-Way Test RMB",
        "30-sec members Self Introduction",
      ],
      color: "from-blue-100 to-blue-200",
      pin: "bg-blue-500",
    },
    {
      num: "03",
      title: "Welcome Visitors",
      details: ["Visitors Introduction", "Visitors 30-sec presentation"],
      color: "from-purple-100 to-purple-200",
      pin: "bg-purple-500",
    },
    {
      num: "04",
      title: "Members Business Presentation",
      details: [
        "Introduction of business presentators",
        "10 minutes Business Presentation each",
        "10 minutes knowledge sharing slot",
      ],
      color: "from-orange-100 to-orange-200",
      pin: "bg-orange-500",
    },
    {
      num: "05",
      title: "Announcements",
      details: [
        "Announce Testimonials ,Pass referrals, Thank You, R2Rs",
        "Announcements and reminders",
      ],
      color: "from-blue-100 to-blue-200",
      pin: "bg-blue-500",
    },
    {
      num: "06",
      title: "Prizes & Closing Quote",
      details: [
        "Prize distribution",
        "Closing of meeting by President with a Quote",
      ],
      color: "from-purple-100 to-purple-200",
      pin: "bg-purple-500",
    },
  ];

const phases2 = [
  {
    title: "Tea/Coffee",
    details: ["Open Networking", "Exchange of Cards- Fellowship"],
    icon: Coffee,
    color: "text-orange-500 border-orange-400",
  },
  {
    title: "Meeting Starts Sharp 8:30AM",
    details: [
      "Welcome everyone, introduce Team Leaders and Coordinators",
      "4-Way Test RMB",
      "30-sec members Self Introduction",
    ],
    icon: Users,
    color: "text-green-500 border-green-400",
  },
  {
    title: "Welcome Visitors",
    details: ["Visitors Introduction", "Visitors 30-sec presentation"],
    icon: Smile,
    color: "text-purple-500 border-purple-400",
  },
  {
    title: "Members Business Presentation",
    details: [
      "Introduction of business presentators",
      "10 minutes Business Presentation each",
      "10 minutes knowledge sharing slot",
    ],
    icon: Presentation, 
    color: "text-blue-500 border-blue-400",
  },
  {
    title: "Announcements",
    details: [
      "Announce Testimonials ,Pass referrals, Thank You, R2Rs",
      "Announcements and reminders",
    ],
    icon: Bell,
    color: "text-indigo-500 border-indigo-400",
  },
  {
    title: "Prizes & Closing Quote",
    details: [
      "Prize distribution",
      "Closing of meeting by President with a Quote",
    ],
    icon: Gift,
    color: "text-pink-500 border-pink-400",
  },
];
  return (
    <div>
      <Header />
      {bannerdata.map((items)=>(
        <div
        className="w-full h-[451px] relative hidden"
        style={{
          backgroundImage: `url(${api}/${items.image.replace(/\\/g, '/')})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        {/* <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div> */}
        <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
          <h2 className=" text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold ">
            {items.title}{" "}
          </h2>
          <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
            {items.content}
          </p>
          <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
            <a
              className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/"
            >
              {" "}
              <FaHome />
              Home
            </a>
            <a
              className="flex  gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/meetings"
            >
              {" "}
              <IoIosArrowForward />
              Meetings{" "}
            </a>
          </div>
        </div>
      </div>
      ))}
      
         {/* letst news      */}
         <div className="bg-[#1E2A3A] py-14 px-[8%] ">
        <div className="flex flex-wrap w-[100%]">
          <div className=" sm:w-[50%]">
            <p className="text-[#F1F4F9] text-[16px] font-normal leading-5 mb-4">
              OUR NEWS / EVENTS
            </p>
            <span className="text-[#F1F4F9] text-[39px] leading-10	font-bold	">
              Our
            </span>
            <span className="text-[39px] leading-10	font-bold	text-[#FDBC12] ml-2">
             Latest Meetings
            </span>
          </div>
          <div className="  sm:w-[50%] md:flex justify-end items-center sm:mt-0 mt-4">
            <button className="bg-[#02256D] w-[150px] py-3 rounded text-[#F1F4F9] text-[16px] font-normal"
            
            >
              View All
            </button>
          </div>
        </div>
        {/* News boxs */}
        
        <BlogList blogs={blogs} count={3}/>
      </div>
      <div className="bg-[#1E2A3A] py-14 px-[8%] flex flex-wrap  gap-y-8 w-[100%] border-b border-[#465468] hidden">
      {pagedata.filter((items)=>items.name==='Meeting Agenda (2 Meetings Per Month)').map((items)=>(
           <div className="lg:w-[48%] w-[100%] pr-5">
           <h2 className="text-[#FDBC12] text-[39px] font-semibold ">
             Meetings
           </h2>
          
           <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
             {items.title}
           </p>
           <ol className="list-decimal text-[#94A2B8] text-[400] ml-4 mt-4 flex flex-col gap-y-4">
            {items.content.split('</br>').map((list)=>(
             <li>{list}</li>
            ))}
           </ol>
         </div> 
          ))}
        
        <div className="lg:w-[48%] w-[100%]">
        {pagedata
    .filter((item) => item.image?.length !== 0) // Filter items with non-empty images
    .map((item, index) => (
      <div
        key={index}
        className={`w-[100%] flex ${
          index % 2 === 0 ? 'justify-end' : 'justify-start'
        } mt-5`}
      >
        <img className="w-[60%]" src={`${api}/${item.image}`} alt="" />
      </div>
    ))}

        </div>
      </div>
      <div className="bg-[#101729] py-14 px-[8%] flex flex-wrap w-[100%] border-b border-[#465468] hidden">
        {pagedata.filter((items)=>items.name==='Meeting Schedules').map((item)=>(
          <div className="md:w-[55%] w-[100%]">
          <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
            {item.title}
          </p>
          <ul className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
            {item.content.split('</br>').map((list)=>(
              <li>
              {list}
            </li>

            ))}
            
            
          </ul>
        </div>
        ))}

{pagedata.filter((items)=>items.name==='Meeting Days In Month').map((item)=>(
           <div className="md:w-[45%] w-[100%] flex md:pl-[60px] md:mt-0 mt-5">
           <div className="w-[1px] h-[156px] bg-[#D9D9D9] mt-5"></div>
           <div className="pl-[80px]">
             <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
              {item.title}
             </p>
             <ul className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
              {item.content.split('</br>').map((list)=>(
                <li>{list}</li>
              ))}
              
             </ul>
           </div>
         </div>
        ))}        
       
      </div>
      {pagedata.filter((items)=>items.name === 'Designations / Leadership Team and Working Committee Roles').map((items)=>(
        <div className="bg-[#101729] py-14 px-[8%] flex flex-wrap w-[100%] border-b border-[#465468] hidden">
      <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">
      {items.title}
          </p>

          <ul className="text-[#94A2B8] text-[16px] flex flex-col gap-y-3 mt-3">
            {items.content.split('</br>').map((list)=>(
              <li>
               
               <b>{list.split(' – ')[0]}</b> - {list.split(' – ')[1]}
            </li>
            ))}
            
          </ul>
      </div>
      ))}
   
      <Meetingagenda/>
     

    
      
      <Footer />
    </div>
  );
};

export default Meetings;
